export const translations = {
  fr: {
    nav: {
      offers: "Nos Offres",
      privatization: "Événements",
      account: "Mon Compte",
      login: "Connexion",
      register: "S'inscrire",
      logout: "Déconnexion",
      staff: "Espace Staff",
    },
    hero: {
      eyebrow: "Boulay Beach Resort",
      tagline: "Life Is Here",
      taglineLine1: "Une île privée, à quelques minutes d'Abidjan.",
      taglineLine2: "Un autre rythme. Une autre énergie.",
      taglineLine3: "Des expériences premium inoubliables.",
      title: "",
      titleAccent: "",
      subtitle: "",
      cta: "Réserver une journée",
      scroll: "Découvrir",
    },
    offers: {
      eyebrow: "Trois invitations",
      title: "Choisissez votre journée",
      subtitle: "Chaque expérience est une parenthèse. Précieuse, lente, lumineuse.",
      from: "À partir de",
      adult: "Adulte",
      child: "Enfant",
      childAge: "(6–12 ans)",
      reserve: "Réserver",
      reservationOnly: "Sur réservation",
      passDayBullets: [
        "Traversée lagunaire aller-retour",
        "Sélection de tapas",
        "Cocktail signature*",
      ],
      sunsetBullets: [],
      brunchBullets: [],
      leKaaiBullets: [
        "Restaurant ouvert tous les jours",
        "11h — 22h30",
      ],
      hebergementBullets: [
        "Suites & chambres signature",
        "Tous les jours · 7j/7",
        "Petit-déjeuner inclus",
      ],
      perNight: "/ nuit",
    },
    booking: {
      step: "Étape",
      of: "sur",
      next: "Suivant",
      back: "Retour",
      step1: "Date",
      step2: "Convives",
      step3: "Vos coordonnées",
      step4: "Récapitulatif",
      step5: "Paiement",
      pickDate: "Sélectionnez une date",
      pickArrival: "Date d'arrivée",
      pickCheckout: "Date de départ",
      nights: "Nuits",
      night: "nuit",
      arrivalLabel: "Arrivée",
      checkoutLabel: "Départ",
      adults: "Adultes",
      children: "Enfants",
      childrenHint: "De 6 à 12 ans",
      adultsHint: "À partir de 13 ans",
      roomType: "Type de chambre",
      rooms: "Chambres",
      roomsHint: "Nombre de chambres à réserver",
      yourInfo: "Vos coordonnées",
      name: "Prénom",
      surname: "Nom",
      nationality: "Nationalité",
      boatTime: "Heure du bateau",
      boatTimeHint: "Horaire de traversée vers Boulay Beach Resort",
      arrivalBoatTime: "Bateau aller",
      arrivalBoatTimeHint: "Traversée vers Boulay Beach Resort le jour d'arrivée",
      returnBoatTime: "Bateau retour",
      returnBoatTimeHint: "Traversée de retour depuis Boulay Beach Resort le jour du départ",
      primaryContact: "Contact principal",
      contactInfo: "Coordonnées du contact principal",
      participantsLabel: "Participants",
      phone: "Téléphone",
      email: "Email",
      specialRequests: "Demandes particulières",
      specialRequestsPlaceholder: "Allergies, occasion spéciale, demandes de placement...",
      summary: "Récapitulatif",
      offer: "Offre",
      date: "Date",
      total: "Total",
      proceedToPayment: "Procéder au paiement",
      confirmReservation: "Confirmer ma réservation",
      leKaaiConfirmDesc: "Le Kaai est sur réservation simple. Aucun paiement n'est requis en avance — réglez votre addition directement au restaurant.",
      payCardLabel: "Paiement en ligne",
      payNow: "Payer en ligne",
      payMobileLabel: "Mobile Money",
      payMobile: "Payer en Mobile Money",
      payMobileDesc: "Orange Money, MTN Money, Moov Money. QR codes générés à la validation du paiement.",
      ticketGreetingLine1: "Voici votre pass, émis suite à votre réservation.",
      ticketGreetingLine2: "Nous vous souhaitons une expérience inoubliable.",
      ticketSignature: "Life is Here.",
      ticketOwner: "Propriétaire",
      ticketOffer: "Offre",
      ticketDate: "Date",
      ticketBoardingTime: "Heure d'embarquement",
      payCash: "Payer en espèce",
      payCashDesc: "Réglez sur place à l'arrivée. Votre ticket reste valide.",
      payDepositLabel: "Acompte sur place",
      payDeposit: "Payer un acompte",
      payDepositDesc: "Réservez avec un acompte. Le solde sera réglé à votre arrivée.",
      payDepositCta: "Acompte",
      balanceDue: "Solde",
      payProcessing: "Paiement en cours...",
      successTitle: "Réservation confirmée",
      successText: "Vos QR codes sont vos passeports. Présentez-les à l'arrivée.",
      qrCodesSingular: "QR code généré",
      qrCodesPlural: "QR codes générés — un par participant",
      download: "Télécharger",
      downloadLivret: "Télécharger le Livret BBR",
      shareRecap: "Envoyer le récapitulatif",
      shareEmail: "Par email",
      shareWhatsapp: "Par WhatsApp",
      cashReceipt: "Reçu temporaire",
      backHome: "Retour à l'accueil",
      confirmationNote: "Une copie de vos QR codes vous a été envoyée à l'email indiqué. Pensez à les télécharger ou en faire une capture avant de quitter cette page.",
      fineoDisclaimer: "Paiement sécurisé en ligne (carte bancaire & mobile money). Vos QR codes seront générés instantanément à la validation du paiement.",
      remaining: "Places restantes",
      capacityFull: "Complet pour cette date",
      missingPrefix: "Champs manquants :",
      missingParticipants: "infos participants",
      missingBoatTime: "heure du bateau",
      missingReturnBoatTime: "heure du bateau retour",
      missingPhone: "téléphone",
      missingEmail: "email valide",
    },
    account: {
      title: "Mon Espace",
      welcome: "Bienvenue",
      myBookings: "Mes Réservations",
      noBookings: "Aucune réservation pour le moment.",
      bookNow: "Réserver maintenant",
      cancel: "Annuler",
      cancelled: "Annulée",
      confirmed: "Confirmée",
      pending: "En attente",
      arrived: "Arrivé",
      completed: "Terminé",
      qrCode: "QR Code",
      pay: "Procéder au paiement",
      confirmCancel: "Confirmer l'annulation ?",
    },
    auth: {
      loginTitle: "Bon retour",
      loginSubtitle: "Connectez-vous à votre espace Boulay",
      registerTitle: "Créer votre compte",
      registerSubtitle: "Quelques instants pour rejoindre l'expérience",
      email: "Email",
      password: "Mot de passe",
      submit: "Continuer",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      signIn: "Se connecter",
      signUp: "S'inscrire",
    },
    events: {
      title: "Privatisation & Événements",
      heroEyebrow: "Privatisation & Événements",
      heroTitle: "L'évènement, à votre image.",
      subtitle:
        "Mariage, séminaire, anniversaire d'exception. Notre équipe orchestre l'évènement à votre image.",
      eventType: "Type d'événement",
      eventDate: "Date souhaitée",
      guestCount: "Nombre d'invités",
      message: "Votre vision",
      submit: "Envoyer la demande",
      sent: "Demande envoyée. Notre équipe vous contactera sous 48h.",
    },
    footer: {
      addr: "Boulay Beach Resort — Abidjan, Côte d'Ivoire",
      rights: "Tous droits réservés.",
      contact: "Contact",
      reservations: "Réservations",
      follow: "Nous suivre",
      legal_terms: "Conditions générales de vente",
      legal_mentions: "Mentions légales",
    },
  },
  en: {
    nav: {
      offers: "Our Offers",
      privatization: "Events",
      account: "My Account",
      login: "Sign In",
      register: "Register",
      logout: "Sign Out",
      staff: "Staff",
    },
    hero: {
      eyebrow: "Boulay Beach Resort",
      tagline: "Life Is Here",
      taglineLine1: "A private island, just minutes from Abidjan.",
      taglineLine2: "A different rhythm. A different energy.",
      taglineLine3: "Unforgettable premium experiences.",
      title: "",
      titleAccent: "",
      subtitle: "",
      cta: "Reserve a day",
      scroll: "Discover",
    },
    offers: {
      eyebrow: "Three invitations",
      title: "Choose your day",
      subtitle: "Each experience is a pause. Precious, slow, luminous.",
      from: "From",
      adult: "Adult",
      child: "Child",
      childAge: "(6–12 yrs)",
      reserve: "Reserve",
      reservationOnly: "Reservation only",
      passDayBullets: [
        "Round-trip lagoon crossing",
        "Tapas selection",
        "Signature cocktail*",
      ],
      sunsetBullets: [],
      brunchBullets: [],
      leKaaiBullets: [
        "Restaurant open every day",
        "11am — 10:30pm",
      ],
      hebergementBullets: [
        "Signature suites & rooms",
        "Open every day · 7/7",
        "Breakfast included",
      ],
      perNight: "/ night",
    },
    booking: {
      step: "Step",
      of: "of",
      next: "Next",
      back: "Back",
      step1: "Date",
      step2: "Guests",
      step3: "Your details",
      step4: "Summary",
      step5: "Payment",
      pickDate: "Select a date",
      pickArrival: "Arrival date",
      pickCheckout: "Departure date",
      nights: "Nights",
      night: "night",
      arrivalLabel: "Arrival",
      checkoutLabel: "Departure",
      adults: "Adults",
      children: "Children",
      childrenHint: "From 6 to 12 years old",
      adultsHint: "From 13 years old",
      roomType: "Room type",
      rooms: "Rooms",
      roomsHint: "Number of rooms to book",
      yourInfo: "Your details",
      name: "First name",
      surname: "Last name",
      nationality: "Nationality",
      boatTime: "Boat time",
      boatTimeHint: "Crossing time to Boulay Beach Resort",
      arrivalBoatTime: "Outbound boat",
      arrivalBoatTimeHint: "Crossing to Boulay Beach Resort on arrival day",
      returnBoatTime: "Return boat",
      returnBoatTimeHint: "Return crossing from Boulay Beach Resort on departure day",
      primaryContact: "Primary contact",
      contactInfo: "Primary contact details",
      participantsLabel: "Participants",
      phone: "Phone",
      email: "Email",
      specialRequests: "Special requests",
      specialRequestsPlaceholder: "Allergies, special occasion, seating preferences...",
      summary: "Summary",
      offer: "Offer",
      date: "Date",
      total: "Total",
      payNow: "Pay online",
      payCash: "Pay in cash",
      payCashDesc: "Pay on arrival at the resort. Your ticket remains valid.",
      payDepositLabel: "Pay a deposit",
      payDeposit: "Pay a deposit",
      payDepositDesc: "Secure your booking with a deposit. Settle the balance on arrival.",
      payDepositCta: "Deposit",
      balanceDue: "Balance",
      payProcessing: "Processing payment...",
      successTitle: "Booking confirmed",
      successText: "Your QR codes are your passports. Present them on arrival.",
      qrCodesSingular: "QR code generated",
      qrCodesPlural: "QR codes generated — one per guest",
      download: "Download",
      downloadLivret: "Download the BBR Booklet",
      shareRecap: "Send the recap",
      shareEmail: "By email",
      shareWhatsapp: "Via WhatsApp",
      cashReceipt: "Temporary receipt",
      backHome: "Back to home",
      confirmationNote: "A copy of your QR codes has been sent to the email provided. Make sure to download them or take a screenshot before leaving this page.",
      fineoDisclaimer: "Secure online payment (bank card & mobile money). Your QR codes will be generated instantly upon payment confirmation.",
      proceedToPayment: "Proceed to payment",
      confirmReservation: "Confirm my reservation",
      leKaaiConfirmDesc: "Le Kaai is reservation-only. No upfront payment is required — settle your bill directly at the restaurant.",
      payCardLabel: "Online payment",
      payMobileLabel: "Mobile Money",
      payMobile: "Pay with Mobile Money",
      payMobileDesc: "Orange Money, MTN Money, Moov Money. QR codes generated on payment validation.",
      ticketGreetingLine1: "Here is your pass, issued upon your reservation.",
      ticketGreetingLine2: "We wish you an unforgettable experience.",
      ticketSignature: "Life is Here.",
      ticketOwner: "Owner",
      ticketOffer: "Offer",
      ticketDate: "Date",
      ticketBoardingTime: "Boarding time",
      remaining: "Spots remaining",
      capacityFull: "Sold out for this date",
      missingPrefix: "Missing fields:",
      missingParticipants: "participant info",
      missingBoatTime: "boat time",
      missingReturnBoatTime: "return boat time",
      missingPhone: "phone",
      missingEmail: "valid email",
    },
    account: {
      title: "My Space",
      welcome: "Welcome",
      myBookings: "My Bookings",
      noBookings: "No bookings yet.",
      bookNow: "Book now",
      cancel: "Cancel",
      cancelled: "Cancelled",
      confirmed: "Confirmed",
      pending: "Pending",
      arrived: "Checked-in",
      completed: "Completed",
      qrCode: "QR Code",
      pay: "Proceed to payment",
      confirmCancel: "Confirm cancellation?",
    },
    auth: {
      loginTitle: "Welcome back",
      loginSubtitle: "Sign in to your Boulay account",
      registerTitle: "Create your account",
      registerSubtitle: "A few moments to join the experience",
      email: "Email",
      password: "Password",
      submit: "Continue",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      signIn: "Sign in",
      signUp: "Sign up",
    },
    events: {
      title: "Privatization & Events",
      heroEyebrow: "Privatization & Events",
      heroTitle: "The event, in your image.",
      subtitle:
        "Wedding, seminar, exceptional birthday. Our team orchestrates the event in your image.",
      eventType: "Event type",
      eventDate: "Desired date",
      guestCount: "Number of guests",
      message: "Your vision",
      submit: "Send request",
      sent: "Request sent. Our team will contact you within 48 hours.",
    },
    footer: {
      addr: "Boulay Beach Resort — Abidjan, Côte d'Ivoire",
      rights: "All rights reserved.",
      contact: "Contact",
      reservations: "Reservations",
      follow: "Follow us",
      legal_terms: "Terms & Conditions",
      legal_mentions: "Legal notice",
    },
  },
};

export const formatXOF = (n) =>
  new Intl.NumberFormat("fr-FR").format(n) + " FCFA";
